import {useNavigate} from "react-router-dom";
import Logo from "../../Assets/images/logo/connectcaremintgreen.png";
import Illustration from "../../Assets/images/illustrations/medicine.svg";
import {useBoundStore} from "../../Store/store";

export const Error403 = () => {
    const navigate = useNavigate();
    const user = useBoundStore(state => state.user);

    const homeForRole = () => {
        if (user?.type === 'admin') return '/admin/registrations';
        if (user?.type === 'customer') return '/customer/shifts';
        if (user?.type === 'freelancer') return '/freelancer/shifts';
        return '/';
    };

    return (
        <>
            <div className="grid min-h-screen grid-cols-1 grid-rows-[1fr,auto,1fr] bg-white lg:grid-cols-[max(50%,36rem),1fr]">
                <header className="mx-auto w-full max-w-7xl px-6 pt-6 sm:pt-10 lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:px-8">
                    <a href="#">
                        <img
                            className="h-10 w-auto sm:h-12"
                            src={Logo}
                            alt=""
                        />
                    </a>
                </header>
                <main className="mx-auto w-full max-w-7xl px-6 py-24 sm:py-32 lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:px-8">
                    <div className="max-w-lg">
                        <p className="text-base font-semibold leading-8 text-primary">403</p>
                        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Geen toegang</h1>
                        <p className="mt-6 text-base leading-7 text-gray-600">
                            Je hebt geen rechten om deze pagina te bekijken.
                        </p>
                        <div className="mt-10 flex flex-row gap-6">
                            <a href="#" onClick={(e) => { e.preventDefault(); navigate(homeForRole()); }} className="text-sm font-semibold leading-7 text-primary">
                                <span aria-hidden="true">&larr;</span> Terug naar startpagina
                            </a>
                        </div>
                    </div>
                </main>
                <div className="hidden lg:relative lg:col-start-2 lg:row-start-1 lg:row-end-4 lg:block">
                    <div className={'w-full p-3 h-full'}>
                        <div
                            className={'relative rounded-lg p-4 flex-col justify-center hidden md:flex h-full w-full'}>
                            <div
                                className={'absolute top-0 left-0 bg-gradient-to-b opacity-20 from-primary to-secondary w-full h-full rounded-lg'}>&nbsp;</div>
                            <img src={Illustration} alt={'Illustration of a doctor'} className={'m-auto max-h-[50%]'}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
